const HABITAT_HELP_UID = '__habitat_help'
const CHATS_COLLECTION = 'chats'
const MESSAGES_COLLECTION = 'messages'

export {
  HABITAT_HELP_UID,
  CHATS_COLLECTION,
  MESSAGES_COLLECTION,
}
